import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
import ValidatedIntInput from "@/components/validated_input/ValidatedIntInput.vue";
import ValidatedTextInput, {
  TextInputValidator,
} from "@/components/validated_input/ValidatedTextInput.vue";
import NewValidatedForm from "@/components/validated_input/NewValidatedForm.vue";
import Toggle from "@/components/toggle.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SimpleForm',
  setup(__props) {

const number_input = ref(42);
const text_input = ref("mars");
const toggleable_input_value = ref(42);
const show_toggleable_input = ref(true);

const is_valid = ref(false);
const is_mars: TextInputValidator = (value) => {
  const is_valid = value === "mars";
  if (is_valid) {
    return { is_valid };
  } else {
    return { is_valid, error_msg: "not mars" };
  }
};

const save_data = () => alert("succesfully saved!");

return { __sfc: true,number_input, text_input, toggleable_input_value, show_toggleable_input, is_valid, is_mars, save_data, ValidatedIntInput, ValidatedTextInput, NewValidatedForm, Toggle }
}

})